import {
  getEquipmentDetailsByValue,
  mapToEquipmentOptionsWithCombinedKiln,
  type EquipmentDto
} from '@domain/kpis'
import {IconWithLabel} from '@hconnect/common/components/shiftEventLabels/IconWithLabel'
import {MenuItem, TextField} from '@mui/material'
import {EQUIPMENT_TYPE_ICON_MAP} from '@widgets/downtime-analytics'
import {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

type EquipmentKpiStatsViewDropdownProps = {
  plantEquipmentsData: EquipmentDto[]
  onChange?: (equipment: string) => void
  selectedEquipmentId: string
  isFullWidth?: boolean
}

type EquipmentOption = {
  value: string
  label: string
  equipmentType?: string
}

const renderMenuItems = (
  options: EquipmentOption[],
  plantEquipments: EquipmentDto[],
  kilnLabel: string
) => {
  return options.map((equipment) => {
    const optionEquipmentType = getEquipmentDetailsByValue(
      equipment.value,
      kilnLabel,
      plantEquipments
    ).equipmentType

    return (
      <MenuItem
        data-test-id={`action-status-dropdown-item-${equipment.value}`}
        key={equipment.value}
        value={equipment.value}
      >
        <IconWithLabel
          icon={<>{EQUIPMENT_TYPE_ICON_MAP[optionEquipmentType]}</>}
          iconOnly={false}
          label={equipment.label}
        />
      </MenuItem>
    )
  })
}

export const EquipmentKpiStatsViewDropdown: FC<EquipmentKpiStatsViewDropdownProps> = ({
  plantEquipmentsData,
  onChange,
  selectedEquipmentId,
  isFullWidth
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const kilnLabel = t('label.kilns')
  const options = mapToEquipmentOptionsWithCombinedKiln(kilnLabel, plantEquipmentsData)
  const selectedOption = options.find(({value}) => {
    return value === selectedEquipmentId
  })

  return (
    <TextField
      fullWidth={isFullWidth}
      variant="filled"
      label={t('label.selectAsset')}
      select
      data-test-id="equipment-kpi-stats-view-dropdown"
      value={selectedOption?.value ?? ''}
      onChange={(event) => {
        onChange?.(event.target.value)
      }}
      sx={{mb: 2, minWidth: 200}}
    >
      {renderMenuItems(options, plantEquipmentsData, kilnLabel)}
    </TextField>
  )
}
